function Register() {
  return <div />;
}

Register.routeProps = {
  exact: true,
  path: '/register',
  disabled: true,
};
export default Register;
